@if (injuryGroups) { @for (seasonData of injuryGroups['seasons']; track $index; let i = $index) { @for
(subtournamentData of seasonData['subtournaments']; track $index; let j = $index) {
<h4 class="head mt-2 ml-2 ml-xl-0">
    {{ seasonData['season']['name'] }}, {{ subtournamentData['subtournament']['name'] }}
</h4>
@for (weekData of subtournamentData['weeks']; track $index; let k = $index) {
<div
    class="table-sport__subhead d-flex align-items-center bg-light {{
        !weekOpened(weekData['week']['id']) ? 'collapsed' : ''
    }}"
    data-toggle="collapse"
    [attr.data-target]="'#collapse-injuries-' + i + '-' + j + '-' + k"
    role="button"
    [attr.aria-expanded]="weekOpened(weekData['week']['id']) ? 'true' : 'false'"
    aria-controls="collapse-injuries-{{ i }}-{{ j }}-{{ k }}"
    (click)="toggleWeek(weekData['week']['id'])"
>
    <div class="table-sport__subhead__text mb-0 text-uppercase text-truncate">
        {{ weekData['week']['name'] ?? 'Week ' + weekData['week']['number'] }}
    </div>
</div>
<div
    class="collapse {{ weekOpened(weekData['week']['id']) ? 'show' : '' }}"
    id="collapse-injuries-{{ i }}-{{ j }}-{{ k }}"
>
    @if (weekData['injuries'] !== null) {
    <div class="d-flex table-scrollable">
        <div class="table-scrollable__data flex-grow-1">
            <table class="table-scrollable__data__table" data-cy="app-table-left-data">
                <thead>
                    <tr>
                        <th class="table-scrollable__table-th" colspan="2">
                            {{ 'web.player' | translate }}
                        </th>
                        <th class="table-scrollable__table-th">
                            {{ 'web.injury' | translate }}
                        </th>
                        <th class="table-scrollable__table-th">
                            {{ 'web.status' | translate }}
                        </th>
                        <th class="table-scrollable__table-th">
                            {{ 'web.practice_status' | translate }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    @for (injuryData of weekData['injuries']; track $index) {
                    <tr class="table-scrollable__table-row">
                        <td class="table-scrollable__table-td text-center" style="width: 44px">
                            <div class="img-circle img-circle--40 mr-3 rounded-circle">
                                <img
                                    (error)="imageError($event, 'avatar')"
                                    [attr.alt]="injuryData.player.name"
                                    [src]="'/assets/players/photos/' + injuryData.player.id + '.png'"
                                    height="40"
                                    loading="lazy"
                                />
                            </div>
                        </td>
                        <td class="table-scrollable__table-td w-25">
                            <a
                                [routerLink]="['/page/sport/player', sportName + '-' + sportId, injuryData.player.id]"
                                class="text-reset table-scrollable-team"
                            >
                                {{ injuryData.player.name }}
                            </a>
                        </td>
                        <td class="table-scrollable__table-td w-25">
                            {{ injuryData.primary }}@if (injuryData.secondary !== null) { ,{{ injuryData.secondary }}
                            }
                        </td>
                        <td class="table-scrollable__table-td">
                            {{ injuryData.status }}
                        </td>
                        <td class="table-scrollable__table-td">
                            {{ injuryData.practice_status }}
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
    } @else {
    <app-placeholder-match></app-placeholder-match>
    }
</div>
} } } } @else {
<app-placeholder-table></app-placeholder-table>
} @if (injuryGroups?.seasons.length === 0) {
<div class="text-center">
    <strong>{{ 'web.no_data_found' | translate }}</strong>
</div>
}
